<div class="page_wrapper">
  <app-header-new></app-header-new>
  <!-- form group -->
  <form [formGroup]="ratingForm">
    <div class="container-fluid wrapper-page header-fix position-relative display-contents" *ngIf="physician">
      <div align="center">
        <h2 class="mt-2 mb-4 text-color font-size-25 font-weight-500">
          FEEDBACK FORM
        </h2>
      </div>
      <div class="row justify-content-center">
        <div class="col-lg-10">
          <div class="bg-primary text-white p-3">
            <h5 class="mt-2 ml-3">APPOINTMENT ID: {{ aptId }}</h5>
          </div>
          <br />
          <div class="bg-primary text-white p-1">
            <h5 class="mt-2 ml-4">YOUR CONSULTING DOCTOR</h5>
          </div>
          <div class="card m-b-30">
            <div class="card-body">
              <div class="row">
                <div class="col-sm-12 col-md-3">
                  <div class="card m-b-30 border-0">
                    <form>
                      <img [src]="physician?.ppurl" class="rounded-circle w-100 h-100" />
                    </form>
                  </div>
                </div>
                <div class="col-md-6 detail-tbl">
                  <h3 class="text-color font-size-20 text-capitalize">
                    {{ physician?.title ? physician?.title : defaultDr }}
                    {{ physician?.first_name }} {{ physician?.last_name }}
                    {{ physician?.qualification }}
                  </h3>
                  <table class="table">
                    <tbody>
                      <tr>
                        <td class="text-color-font font-size-16 pl-0 border-0">
                          Speciality
                        </td>
                        <td class="text-change font-size-16 font-weight-500 text-capitalize border-0">
                          {{ physician_model?.speciality }}
                        </td>
                      </tr>
                      <!--<tr>
                      <td class="text-color-font font-size-16 pl-0 border-0">Education</td>
                      <td class="text-change  font-size-16 font-weight-500 text-capitalize border-0">
                        {{physician_model?.education}}
                      </td>
                    </tr> -->
                      <tr>
                        <td class="text-color-font font-size-16 pl-0 border-0">
                          University
                        </td>
                        <td class="text-change font-size-16 font-weight-500 text-capitalize border-0">
                          {{ physician_model?.university }}
                        </td>
                      </tr>
                      <tr>
                        <td class="text-color-font font-size-16 pl-0 border-0">
                          Location
                        </td>
                        <td class="text-change font-size-16 font-weight-500 text-capitalize border-0">
                          {{ physician?.city }}{{ physician_model?.location }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div class="bg-primary text-white p-1">
            <h5 class="mt-2 ml-4">RATE PHYSICIAN</h5>
          </div>
          <div class="card m-b-30">
            <div class="card-body">
              <div class="row">
                <div class="col-sm-3">
                  <div class="rating cursor mt-4">
                    <!-- <star-rating value="0" [checkedcolor]="feedbackColors?.CHECKED"
                    [uncheckedcolor]="feedbackColors?.UNCHECKED" [size]="starSize" readonly="false"
                    (rate)="onRate($event, feedbackType?.PHYSICIAN)"></star-rating> -->

                    <ngb-rating style="font-size: 1.5rem" [max]="5" [(rate)]="physicianRating"></ngb-rating>
                  </div>
                </div>
                <div class="col-sm-9">
                  <textarea class="form-control pt-3 pb-3 font-size-16 desc-height" rows="10"
                    placeholder="Please Provide Your Comments" formControlName="physicianRatingComment"></textarea>
                </div>
              </div>
            </div>
          </div>
          <div class="bg-primary text-white p-1">
            <h5 class="mt-2 ml-4">RATE Reliable Doctors APPLICATION</h5>
          </div>
          <div class="card m-b-30">
            <div class="card-body">
              <div class="row">
                <div class="col-sm-3">
                  <div class="rating cursor mt-4">
                    <!-- <star-rating
                    value="0"
                    [checkedcolor]="feedbackColors?.CHECKED"
                    [uncheckedcolor]="feedbackColors?.UNCHECKED"
                    size="24px"
                    readonly="false"
                    (rate)="onRate($event, feedbackType?.SOOPERDR)"
                  ></star-rating> -->
                    <ngb-rating style="font-size: 1.5rem" [max]="5" [(rate)]="sooperDrRating"></ngb-rating>
                  </div>
                </div>
                <div class="col-sm-9">
                  <textarea class="form-control pt-3 pb-3 desc-height font-size-16" rows="10"
                    placeholder="Please Provide Your Comments" formControlName="sooperDrRatingComment"></textarea>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="text-center">
        <button type="button" class="btn btn-primary btn-lg w-31" (click)="submitFeedback()">
          SUBMIT
        </button>
      </div>
    </div>
  </form>
  <!-- form group -->

  <div class="container-fluid header-fix position-relative display-contents" *ngIf="!physician">
    <div class="row justify-content-center">
      <div class="col-lg-10">
        <div class="card m-b-30">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-12 mt-2 text-center">
                <h5 class="text-danger">NO PHYSICIAN FOUND</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-footer-new></app-footer-new>
</div>